import { render, staticRenderFns } from "./ConceptSelector.vue?vue&type=template&id=704bdc82&scoped=true"
import script from "./ConceptSelector.vue?vue&type=script&lang=js"
export * from "./ConceptSelector.vue?vue&type=script&lang=js"
import style0 from "./ConceptSelector.vue?vue&type=style&index=0&id=704bdc82&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704bdc82",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Quantification/ConceptSelector.vue
// module id = 257
// module chunks = 31